import { useContext, useEffect, useState } from "react";
import { getAllRubros } from "../services/general.services";
import { TenantsContext } from "../../../context/tenants.context";

const useRubros = () => {
  const [rubros, setRubros] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { tenant } = useContext(TenantsContext);

  useEffect(() => {
    setLoading(true);
    getAllRubros(tenant)
      .then(({ data }) => {
        setRubros(data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return {
    rubros,
    setRubros,
    loading,
  };
};
export default useRubros;
